import { Box, Typography } from '@mui/material'
import { StyledContainerColumnLeft, StyledContainerRowBetween } from '../../../../styles/ContainerStyles'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import { t } from 'i18next'

type SidebarTitleProps = {
  isDownSm: boolean
}

const NotificationSidebarTitle = ({ isDownSm }: SidebarTitleProps) => {
  return (
    <StyledContainerRowBetween sx={{ flexDirection: isDownSm ? 'column' : 'row', px: 0.5 }}>
      <Box sx={{ gap: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <NotificationsActiveIcon sx={{ fontSize: 36 }} />
        <StyledContainerColumnLeft>
          <Typography variant="h5" component="h1" color={'text.highEmphasis'}>
            {t('components.notificationSidebar.title')}
          </Typography>
        </StyledContainerColumnLeft>
      </Box>
    </StyledContainerRowBetween>
  )
}

export default NotificationSidebarTitle
